// extracted by mini-css-extract-plugin
export default {"tablist":"TabList_tablist__J2Rgl","buttonTab":"TabList_buttonTab__7Yx0l","iconBtn":"TabList_iconBtn__4dUHB"};